<template>
  <div id="helpContainer">
    <h1>{{ $t('help.title') }}</h1>
    <collapsible-help-question
      v-for="(question, index) in topLevelQuestions"
      :key="index"
      :questionInfo="question"
      :indent="0"
    />
  </div>
</template>

<script>
import Bowser from 'bowser'
import CollapsibleHelpQuestion from '@/components/CollapsibleHelpQuestion'

export default {
  name: 'HelpComponent',
  components: {
    CollapsibleHelpQuestion
  },
  data () {
    return {
      topLevelQuestions: null,
      os: ''
    }
  },
  created () {
    const bowserParser = Bowser.getParser(window.navigator.userAgent)
    const clientInfo = bowserParser.getResult()
    this.os = clientInfo?.os?.name.toLowerCase()
    this.topLevelQuestions = [this.$t('help.files')]
    if (this.os === 'ios' || this.os === 'android') {
      this.topLevelQuestions.push(...this.$t(`help.${this.os}.questions`))
    } else {
      console.error('Unknown OS for displaying help info. Showing both ios and android.')
      this.topLevelQuestions.push(...this.$t('help.ios.questions'))
      this.topLevelQuestions.push(...this.$t('help.android.questions'))
    }
  }
}
</script>

<style scoped>
  * {
    color: white;
  }
  #helpContainer {
    display: flex;
    flex-direction: column;
    margin: 3% 10%;
  }
  h1 {
    font-size: 30px;
    padding-bottom: 10px;
  }
</style>
